import script from "./TitleBtn.vue?vue&type=script&lang=js&setup=true"
export * from "./TitleBtn.vue?vue&type=script&lang=js&setup=true"

import "./TitleBtn.vue?vue&type=style&index=0&id=41e34ce9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41e34ce9"]])

export default __exports__